import React from 'react';
import { Link } from 'gatsby';

import './ArrowLink.scss';
import { ITealiumConfig } from '../../../utils/models';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

export interface IArrowLinkProps {
  text: string;
  path: string;
  rel?: string;
  target?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
  tabIndex?: number;
  tealiumConfig?: ITealiumConfig;
  external?: boolean;
}

const ArrowLink = ({
  text,
  path,
  rel = '',
  target = '',
  ariaLabel,
  ariaHidden = false,
  tabIndex = 0,
  tealiumConfig,
  external = false,
}: IArrowLinkProps) => {
  const handleClick = () => {
    if (
      tealiumConfig &&
      tealiumConfig.dataLinkName &&
      tealiumConfig.dataLinkType
    ) {
      tealiumTrackEvent({
        linktype: tealiumConfig.dataLinkType,
        linkname: tealiumConfig.dataLinkName,
      });
    }
  };
  return external ? (
    <a
      className="arrow-link"
      href={path}
      rel={rel}
      target={target}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      tabIndex={tabIndex}
      onClick={handleClick}
      data-linktype={tealiumConfig && tealiumConfig.dataLinkType}
      data-linkname={tealiumConfig && tealiumConfig.dataLinkName}
    >
      {text}
      <span className="chevron--right" />
    </a>
  ) : (
    <Link
      className="arrow-link"
      to={path}
      rel={rel}
      target={target}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      tabIndex={tabIndex}
      onClick={handleClick}
      data-linktype={tealiumConfig && tealiumConfig.dataLinkType}
      data-linkname={tealiumConfig && tealiumConfig.dataLinkName}
    >
      {text}
      <span className="chevron--right" />
    </Link>
  );
};

export default ArrowLink;
